module.exports = __webpack_public_path__ + "static/img/4946_phase_function_Paper_Points.f4fd93f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4946_phase_function_Paper_Points.png
// module id = F3Lw
// module chunks = 0